import React from 'react'
import { ApiGetCall } from '../../../JS/Connector';
import { formatDateToMMDDYYYY, HideLoder, sanitizeCSVField, ShowLoder } from '../../../JS/Common';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import useConfig from '../../../Hooks/useConfig';

export default function ExportDeviceModels({ FilterData }) {
    const { adminCallNode } = useConfig();
    const [loading, setLoading] = useState(false);
    const [InventoryDataCsv, setInventoryDataCsv] = useState([]);
    const [divVisibleForExport, setDivVisibleForExport] = useState({
        forUsers: false,
        forUsersNoRecord: false
    });

    const headers = [
        { label: "Device Manufacturer", key: "device_manufacturer" },
        { label: "Device Model", key: "device_model" },
        { label: "Parts (Optional)", key: "device_parts" },
    ];

    const FIELDS_TO_SANITIZE = ['device_manufacturer', 'device_model', 'device_parts'];

    function downloadCSV(data) {
        const headerRow = headers.map(h => h.label).join(',');

        const rows = data.map(row =>
            headers.map(h => sanitizeCSVField(h.key, row[h.key], FIELDS_TO_SANITIZE)).join(',')
        );

        const csvContent = [headerRow, ...rows].join('\r\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'DeviceModels.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }

    async function ExportInventory() {
        setLoading(true);
        await ApiGetCall(`${adminCallNode}/device-models/export?startDate=${formatDateToMMDDYYYY(FilterData.StartDate)}&endDate=${formatDateToMMDDYYYY(FilterData.EndDate)}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs.data.length != 0) {
                    setInventoryDataCsv(responseRs.data);
                    setDivVisibleForExport({ ...divVisibleForExport, forUsers: true });
                } else {
                    setInventoryDataCsv([]);
                    setDivVisibleForExport({ ...divVisibleForExport, forUsersNoRecord: true });
                }
                setLoading(false);
            }
        });
    }

    function RemoveUserCsv() {
        setInventoryDataCsv([]);
        setDivVisibleForExport({ ...divVisibleForExport, forUsers: false, forUsersNoRecord: false });
    }

    return (
        <div>
            {loading ? <ShowLoder /> : <HideLoder />}
            <div className='row d-flex align-items-center p-1'>
                <span className='GridTitle'>Export Device Models</span>
            </div>
            <div className='col-12'>
                <img src='/images/HorizontalLine.svg' className='img-fluid w-100' />
            </div>
            <div className="p-2">
                <p className="text-justify" style={{ fontSize: "13px" }}>
                    Would you like to export your device models data? To do so, simply click on the 'Export Device Models' button.
                </p>
                <div className="row pt-3 pb-2 px-3">
                    <div className="col-12 px-0 py-2">
                        <label className='BorderBtnForimportExport' onClick={ExportInventory}>Export Device Models
                            <img src='/images/ExportInventory.svg' className='img-fluid ps-2' />
                        </label>
                    </div>

                </div>
                {divVisibleForExport.forUsers &&
                    <div className="row pt-2" >
                        <div>Your Device Models CSV file is now ready for download. Please click the button below to initiate the file download.</div>
                        <div className="col-12 mt-1 text-center">
                            <label style={{ fontSize: "12px", color: "#04ADFD" }}>
                                DeviceModels.csv
                            </label>
                            <button className='SaveBtn ms-4' onClick={() => downloadCSV(InventoryDataCsv)}>Download</button>
                            <FontAwesomeIcon icon={faCircleXmark} className="cursor-pointer ps-3" onClick={RemoveUserCsv} />
                        </div>
                    </div>
                }
                {divVisibleForExport.forUsersNoRecord &&
                    <div className="row pt-2">
                        <div className="custom-text-danger">No Record Found!</div>
                    </div>
                }
            </div>

        </div>
    )
}
